import { useLocation } from 'react-router'

export function useIncludePricesRouteParam() {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const includePriceGuides = params.get('include_prices') === true.toString()
  return includePriceGuides
}
